import React, { useEffect, useState } from 'react';
import { InputNumber } from 'rsuite';
import { Button, Modal } from '@nsi-advisory-services/components';

// Payroll settings that are one value for the whole company.
//
// Per-employee retirement elections are NOT here - they live on each
// employee's own record, in the Compensation card of the manage-users edit
// screen, beside the pay rate they are calculated against. What is left is the
// match rate, which is a plan term rather than anything negotiated per person.
// The PATO policy is under Admin > Configuration > Time Off.
//
// Part of the company-specific payroll module; see config/payrollFeature.js.

export default function PayrollSettingsModal({ open, onClose, employerMatchPercent, onSave, saving }) {
  const [matchPercent, setMatchPercent] = useState(employerMatchPercent);
  const [error, setError] = useState(null);

  // Reopening discards an unsaved edit rather than resuming one the user has
  // forgotten about.
  useEffect(() => {
    if (open) {
      setMatchPercent(employerMatchPercent);
      setError(null);
    }
  }, [open, employerMatchPercent]);

  const changed = String(matchPercent) !== String(employerMatchPercent);

  const handleSave = async () => {
    const next = Number(matchPercent);
    if (!Number.isFinite(next) || next < 0 || next > 100) {
      setError('Employer match must be a percentage between 0 and 100.');
      return;
    }
    setError(null);
    await onSave(next);
  };

  return (
    <Modal open={open} onClose={onClose} size="xs">
      <Modal.Header>
        <Modal.Title>Payroll settings</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {error ? (
          <div className="payroll-elections__error">
            <i className="bi bi-exclamation-triangle" aria-hidden="true" /> {error}
          </div>
        ) : null}

        <div className="payroll-elections__match">
          <div className="payroll-elections__match-label">Employer match</div>
          <InputNumber
            value={matchPercent}
            onChange={setMatchPercent}
            onFocus={(event) => event.target.select()}
            min={0}
            max={100}
            step={1}
            postfix="%"
            className="payroll-elections__match-input"
          />
        </div>

        <p className="text-muted" style={{ fontSize: 13, marginTop: 16, marginBottom: 0 }}>
          Each employee&rsquo;s own 401(k) and Roth deferrals are set on their employee record, under Compensation.
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={onClose} disabled={saving}>Cancel</Button>
        <Button variant="primary" onClick={handleSave} loading={saving} disabled={!changed}>Save</Button>
      </Modal.Footer>
    </Modal>
  );
}
